export default "__VITE_ASSET__Dky5b1eg__"